
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {Button, Form, Input, Icon, Checkbox} from 'antd';

class LoginFormComponent extends Component {

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          <label>Ваш логин</label>
          {getFieldDecorator('userName', {
            rules: [{ required: true, message: 'Пожалуйста введите ваш логин!' }],
          })(
            <Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Телефон в формате 9250050011" />
          )}
        </Form.Item>
        <Form.Item>
          <label>Ваш пароль</label>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Пожалуйста введите ваш пароль' }],
          })(
            <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Пароль" />
          )}
        </Form.Item>
        <Form.Item style={{ marginTop: 12 }}>
          <Button size="large" type="primary" htmlType="submit" className="lg-btn" loading={this.props.loading}>
            Войти
          </Button>
        </Form.Item>
      </Form>
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submit(values);
      }
    });
  }

}


export const LoginForm = Form.create({ name: 'login_form' })(LoginFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/auth/forms/login.js